import { AlertCircle, Check } from "lucide-react";
import { INQUIRY_SERVICES } from "../../../data/formOptions";

/**
 * Services multi-select — champagne-gold pill toggles.
 *
 * At least one service must be selected before the form submits.
 * The parent hook tracks `form.services` as an array of slug strings.
 */
export default function ServicesField({ form, errors, setField }) {
    const selected = form.services;

    const toggle = (value) => {
        const next = selected.includes(value)
            ? selected.filter((v) => v !== value)
            : [...selected, value];
        setField("services", next);
    };

    return (
        <div data-testid="inquiry-services-field">
            <div className="flex items-baseline justify-between mb-4">
                <label
                    className="text-[11px] tracking-[0.32em] uppercase text-[#C9A86A]"
                    id="i_services-label"
                >
                    Services <span aria-hidden="true">*</span>
                </label>
                <span className="text-[11px] text-[#5e5a52] tracking-wider">
                    {selected.length > 0
                        ? `${selected.length} selected`
                        : "Select one or more"}
                </span>
            </div>

            <div
                className="flex flex-wrap gap-2.5"
                role="group"
                aria-labelledby="i_services-label"
            >
                {INQUIRY_SERVICES.map((s) => {
                    const isOn = selected.includes(s.value);
                    return (
                        <button
                            key={s.value}
                            type="button"
                            onClick={() => toggle(s.value)}
                            aria-pressed={isOn}
                            data-testid={`inquiry-service-${s.value}`}
                            className={[
                                "group inline-flex items-center gap-2 px-4 py-2.5 rounded-full",
                                "text-[13px] tracking-[0.02em] transition-all duration-300 ease-out",
                                "focus:outline-none focus-visible:ring-2 focus-visible:ring-[#C9A86A] focus-visible:ring-offset-2 focus-visible:ring-offset-[#0B0B0C]",
                                isOn
                                    ? "bg-[#C9A86A] text-[#0B0B0C] border border-[#C9A86A] shadow-[0_0_0_1px_rgba(201,168,106,0.35)]"
                                    : "bg-transparent text-[#F3EFE7] border border-[rgba(201,168,106,0.35)] hover:border-[#C9A86A] hover:text-[#C9A86A]",
                            ].join(" ")}
                        >
                            <Check
                                size={12}
                                strokeWidth={2.2}
                                className={[
                                    "transition-opacity duration-300",
                                    isOn ? "opacity-100" : "opacity-0",
                                ].join(" ")}
                                aria-hidden="true"
                            />
                            {s.label}
                        </button>
                    );
                })}
            </div>

            {errors.services && (
                <p
                    id="i_services-error"
                    role="alert"
                    className="mt-3 flex items-center gap-2 text-[12px] text-[#C97A6A]"
                    data-testid="inquiry-services-error"
                >
                    <AlertCircle size={12} strokeWidth={1.6} />
                    {errors.services}
                </p>
            )}
        </div>
    );
}
